import { connect } from "react-redux";

var CurrentUser = require("lib/account/CurrentUser");
var DropDownOptions = require("components/utility/DropDownOptions");
var SchoolYearMonthsPreference = require("components/users/teachers/preferences/SchoolYearMonthsPreference");
var ExpectationPeriodPreference = require("components/org/preferences/ExpectationPeriodPreference");
var GradeLevelExpectationsPreference = require("components/org/preferences/GradeLevelExpectationsPreference");

require("org/preferences/general_org_preferences.scss");

@connect(
	(state, props) => {
		return {
		}
	},

	(dispatch, props) => ({
		onChange: (prefsUpdate, message) => {
			// Will get moved to redux at some point (soon, I hope)
			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			var adminID = CurrentUser.get().id;
			var params = { admin: { prefs: prefsUpdate } };

			var newPrefs = _.extend({}, CurrentUser.get().prefs, prefsUpdate);
			CurrentUser.updateLocal({ prefs: newPrefs });

			CurrentUser.api().patchAdmin(adminID, params, $wr.apiHandler(function(response) {
			}.bind(this)));
		}
	})
)

class GeneralOrgPreferences extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		
		return (
			<div className="GeneralOrgPreferences">
				<header className="pageHeader">
					<h2>School Year</h2>
				</header>
				<SchoolYearMonthsPreference />
				<header className="pageHeader">
					<h2>Expectation Period</h2>
				</header>
				<ExpectationPeriodPreference />
				<h2>Grade Level Expectations</h2>
				<GradeLevelExpectationsPreference />
			</div>
		)
	}

}


GeneralOrgPreferences.WrappedComponent.propTypes = StrictPropTypes({
	onChange: PropTypes.func.isRequired
});

module.exports = GeneralOrgPreferences;


// WEBPACK FOOTER //
// ./modules/components/org/preferences/GeneralOrgPreferences.js